import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { SUPPORTED_LANG_CODES, getPathWithLang, getPathWithoutLang } from '@/i18n';

const BASE_URL = 'https://chromedinogame.com';

/**
 * Dynamically injects hreflang link tags into the document head.
 * Called once in App.tsx to keep hreflang tags in sync with the current URL.
 */
export function useHreflang() {
  const [location] = useLocation();

  useEffect(() => {
    // Remove existing hreflang tags
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    const cleanPath = getPathWithoutLang(location);

    // Add hreflang for each supported language
    SUPPORTED_LANG_CODES.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      const langPath = getPathWithLang(cleanPath, lang);
      link.href = `${BASE_URL}${langPath}`;
      document.head.appendChild(link);
    });

    // Add x-default pointing to English
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = `${BASE_URL}${cleanPath}`;
    document.head.appendChild(xDefault);

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${BASE_URL}${location}`;

  }, [location]);
}
